export default __webpack_public_path__ + "static/media/clock.15344d46.webp";